import { animals, colors } from "./constant";

const getUniqueCombinations = (
  animals: string[],
  colors: string[]
): string[] => {
  return animals.reduce<string[]>((acc, animal) => {
    colors.forEach((color) => {
      acc.push(`${animal}_${color}`);
    });

    return acc;
  }, []);
};

export const getUniqueAvatarCombinations = () => {
  return getUniqueCombinations(animals, Object.keys(colors));
};
